<script>
  import { onMount } from 'svelte'

  import { parse, parseUrl } from 'query-string'

  import { formfldvalselected,
           pagectxstate,
           subjsearchparams } from './stores'

  import FormTable, { isRowMatch } from './FormTable.svelte' 

  import { getApiUrl, showPage, fetchWithSession } from './util.js'

  let mounted 

  let subject
  let subjectforms

  let errorMessage

  // TODO: Save for re-setting.
  let selectedRow 

  $: { handlePageCtxStateChange($pagectxstate) }
  async function handlePageCtxStateChange(pgctxstate) {
    if (mounted) {
      const parsedurl = parseUrl(pgctxstate.path)
      console.log(parsedurl)
      if (parsedurl.query.subject != subject ||
          $subjsearchparams.subject !== subject) {
        loadSubjectForms()
      }
    }
  }

  async function loadSubjectForms() {
    console.log('loadSubjectForms')
    const querystring = location.search
    const params = parse(querystring)

    console.log(params)

    if (params.subject) {
      subject = params.subject
    } else {
      subject = $subjsearchparams.subject
    }

    if (subject) {
      const apiurl = getApiUrl(`forms`, { subject: subject })
      let res
      try {
        res = await fetchWithSession(apiurl, { cache: 'no-store' })
      } catch (err) {
        console.log(err)
      }
      if (res?.ok) {
        errorMessage = null
        subjectforms = await res.json()
        $subjsearchparams = { subject }
        console.log(subjectforms)
      } else {
        errorMessage = "Error using API to get subject's forms"
        subjectforms = null
        $subjsearchparams = { subject }
        console.dir(res)
        res?.text().then(t => console.log(t))
      }
    }
  }


  function handleSearchInputKeyDown(e) {
    if (e.key === "Enter") {
      search()
    }
  }

  //const search = () => dispatch('search')
  function search() {
    if (subject) {
      //getActiveElementNoBody()?.blur()
      showPage('/subj', {subject})
    } else {
      alert('Subject must be specified for search')
    }
  }


  async function handleRowKeydown(e) {
    const { row, key, isRowSelected } = e.detail
    if (key === 'F' && isRowSelected) {
      $formfldvalselected = { formid: null,
                              formfieldid: null }
      showPage('/form', { frm: row.formid })
    }
  }


  onMount( () => {
    mounted = true
    console.log('onMount SubjectPage')

    loadSubjectForms()
  })


  const columns = [
    { key: 'subject',
      title: 'PID',
      value: v=>v.subject,
      sortable: true },
    { key: 'shortformname',
      title: 'Form name',
      value: v=>v.shortformname,
      sortable: true },
    { key: 'repeatinstance',
      title: '#',
      value: v=>v.repeatinstance ?? '',
      sortable: true },
    { key: 'namespacename',
      title: 'Namespace',
      value: v=>v.namespacename ?? '',
      sortable: true },
    { key: 'inforeqstatus',
      title: 'Info req status',
      value: v=>v.inforeqstatus ?? '',
      sortable: true },
    //{ key: 'errorstatus',
    //  title: 'Error status',
    //  value: v=>v.errorstatus ?? '',
    //  sortable: true },
    //{ key: 'querycontrol',
    //  title: 'Query control',
    //  value: v=>v.querycontrol ?? '',
    //  sortable: true }
  ]

</script>

<div class="searchparams" on:keydown={handleSearchInputKeyDown}>
  <label class=subjectlabel for=subjectinput>
    PID 
  </label>
  <input id="subjectinput" class=subjectinput maxlength=12 bind:value={subject} />
  <button tabindex=-1 on:click={search}>Search</button>
</div>

{#if errorMessage}
  <div>{ errorMessage }</div>
{/if}

{#if subjectforms?.length}
  <h3>Participant forms</h3>

  <div>
  <FormTable rows={ subjectforms }
             { columns }
             bind:selectedRow
             on:rowkeydown={ handleRowKeydown } />
  </div>
{/if}